import { render, staticRenderFns } from "./InstallPWA.vue?vue&type=template&id=09e8e26c&scoped=true&"
import script from "./InstallPWA.vue?vue&type=script&lang=js&"
export * from "./InstallPWA.vue?vue&type=script&lang=js&"
import style0 from "./InstallPWA.vue?vue&type=style&index=0&id=09e8e26c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e8e26c",
  null
  
)

export default component.exports